export default {"src":"/_next/static/media/no-img.a6c11eee.svg","height":459,"width":358,"blurWidth":0,"blurHeight":0};